import {Button} from '@/components/ui/button/Button'
import {AccountEditingSection, useAccountStore} from '../../store/useAccountStore'
import {useTranslation} from '@/translations/i18n'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ReactElement} from 'react'

export const AccountEditProfileHeader = ({
    title,
    field
}: {
    title: ReactElement
    field: NonNullable<AccountEditingSection>
}) => {
    const {t} = useTranslation()
    const editingSection = useAccountStore(state => state.editingSection)
    const setEditingSection = useAccountStore(state => state.setEditingSection)

    return (
        <Flexbox justify="space-between" fullWidth>
            {title}
            <Button
                variant="tertiaryPrimary"
                shape="text"
                onClick={() => setEditingSection(editingSection != field ? field : null)}
            >
                {editingSection != field ? t('commons:edit') : t('commons:cancel')}
            </Button>
        </Flexbox>
    )
}
